//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    getPutPresignedUrl(fileId?: string | undefined): Promise<PreSignedUrlModel> {
        let url_ = this.baseUrl + "/api/v1/blob/put?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPutPresignedUrl(_response);
        });
    }

    protected processGetPutPresignedUrl(response: Response): Promise<PreSignedUrlModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreSignedUrlModel;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreSignedUrlModel>(null as any);
    }

    /**
     * @param search (optional) 
     * @param seriesId (optional) 
     * @param isPublish (optional) 
     * @param page (optional) 
     * @param perPage (optional) 
     * @return Success
     */
    getCarModels(search?: string | null | undefined, seriesId?: string | null | undefined, isPublish?: boolean | null | undefined, page?: number | undefined, perPage?: number | undefined): Promise<CarModelDataGrid> {
        let url_ = this.baseUrl + "/api/v1/car-model?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (seriesId !== undefined && seriesId !== null)
            url_ += "seriesId=" + encodeURIComponent("" + seriesId) + "&";
        if (isPublish !== undefined && isPublish !== null)
            url_ += "isPublish=" + encodeURIComponent("" + isPublish) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCarModels(_response);
        });
    }

    protected processGetCarModels(response: Response): Promise<CarModelDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CarModelDataGrid;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarModelDataGrid>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertCarModel(body?: CreateCarModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/car-model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertCarModel(_response);
        });
    }

    protected processInsertCarModel(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    deleteCarModel(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/car-model/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCarModel(_response);
        });
    }

    protected processDeleteCarModel(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getCarModelDetail(id: string): Promise<CarModelDetailView> {
        let url_ = this.baseUrl + "/api/v1/car-model/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCarModelDetail(_response);
        });
    }

    protected processGetCarModelDetail(response: Response): Promise<CarModelDetailView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CarModelDetailView;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarModelDetailView>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editCarModel(id: string, body?: EditCarModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/car-model/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditCarModel(_response);
        });
    }

    protected processEditCarModel(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param query (optional) 
     * @param seriesCode (optional) 
     * @param isPublish (optional) 
     * @return Success
     */
    getCarModelSearch(query?: string | null | undefined, seriesCode?: string | null | undefined, isPublish?: boolean | null | undefined): Promise<CarModelListItem[]> {
        let url_ = this.baseUrl + "/api/v1/car-model/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (seriesCode !== undefined && seriesCode !== null)
            url_ += "seriesCode=" + encodeURIComponent("" + seriesCode) + "&";
        if (isPublish !== undefined && isPublish !== null)
            url_ += "isPublish=" + encodeURIComponent("" + isPublish) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCarModelSearch(_response);
        });
    }

    protected processGetCarModelSearch(response: Response): Promise<CarModelListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CarModelListItem[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarModelListItem[]>(null as any);
    }

    /**
     * @return Success
     */
    getCarModelDetailV2(id: string): Promise<CarModelDetailV2View> {
        let url_ = this.baseUrl + "/api/v2/car-model/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCarModelDetailV2(_response);
        });
    }

    protected processGetCarModelDetailV2(response: Response): Promise<CarModelDetailV2View> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CarModelDetailV2View;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarModelDetailV2View>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editCarModelV2(id: string, body?: EditCarModelV2 | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/car-model/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditCarModelV2(_response);
        });
    }

    protected processEditCarModelV2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteCarModelV2(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v2/car-model/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCarModelV2(_response);
        });
    }

    protected processDeleteCarModelV2(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertCarModelV2(body?: CreateCarModelV2Model | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v2/car-model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertCarModelV2(_response);
        });
    }

    protected processInsertCarModelV2(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertCarSeries(body?: CreateEditCarSeriesModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/car-series";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertCarSeries(_response);
        });
    }

    protected processInsertCarSeries(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param page (optional) 
     * @param perPage (optional) 
     * @param q (optional) 
     * @param type (optional) 
     * @return Success
     */
    getCarSeries(page?: number | undefined, perPage?: number | undefined, q?: string | null | undefined, type?: string | null | undefined): Promise<CarSeriesListItemDataGrid> {
        let url_ = this.baseUrl + "/api/v1/car-series?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCarSeries(_response);
        });
    }

    protected processGetCarSeries(response: Response): Promise<CarSeriesListItemDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CarSeriesListItemDataGrid;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarSeriesListItemDataGrid>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCarSeries(id: string, body?: CreateEditCarSeriesModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/car-series/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCarSeries(_response);
        });
    }

    protected processUpdateCarSeries(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    deleteCarSeries(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/car-series/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCarSeries(_response);
        });
    }

    protected processDeleteCarSeries(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getCarSeriesDetails(id: string): Promise<CarSeriesDetailViewModel> {
        let url_ = this.baseUrl + "/api/v1/car-series/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCarSeriesDetails(_response);
        });
    }

    protected processGetCarSeriesDetails(response: Response): Promise<CarSeriesDetailViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CarSeriesDetailViewModel;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarSeriesDetailViewModel>(null as any);
    }

    /**
     * @return Success
     */
    getTop10OutletBIB(): Promise<TopServiceOrderListModel> {
        let url_ = this.baseUrl + "/api/v1/dashboard-cms-bib/get-outlet-order";

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTop10OutletBib(_response);
        });
    }

    protected processGetTop10OutletBib(response: Response): Promise<TopServiceOrderListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <TopServiceOrderListModel>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopServiceOrderListModel>(<any>null);
    }

    /**
     * @return Success
     */
    getTop10DealerBIB(): Promise<TopServiceOrderListModel> {
        let url_ = this.baseUrl + "/api/v1/dashboard-cms-bib/get-dealer-order";

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTop10DealerBib(_response);
        });
    }

    protected processGetTop10DealerBib(response: Response): Promise<TopServiceOrderListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <TopServiceOrderListModel>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopServiceOrderListModel>(<any>null);
    }

    /**
     * @param area (optional)  
     * @param dealer (optional) 
     * @param outlet (optional)
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    getBIBChartData(area: string | null | undefined, dealer: string | null | undefined, outlet: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<DashboardChartDataModel> {
        let url_ = this.baseUrl + "/api/v1/dashboard-cms-bib/get-bib-chart-data?";
        if (area !== undefined && area !== null)
            url_ += "Area=" + encodeURIComponent("" + area) + "&";
        if (dealer !== undefined && dealer !== null)
            url_ += "Dealer=" + encodeURIComponent("" + dealer) + "&";
        if (outlet !== undefined && outlet !== null)
            url_ += "Outlet=" + encodeURIComponent("" + outlet) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toLocaleString() : "") + "&";

        url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toLocaleString() : "" + new Date().toLocaleString()) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBibChartData(_response);
        });
    }

    protected processGetBibChartData(response: Response): Promise<DashboardChartDataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <DashboardChartDataModel>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardChartDataModel>(<any>null);
    }

    /**
     * @return Success
     */
    getTop10OutletStall(): Promise<TopServiceOrderListModel> {
        let url_ = this.baseUrl + "/api/v1/dashboard-cms-stall/get-outlet-order";

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTop10OutletStall(_response);
        });
    }

    protected processGetTop10OutletStall(response: Response): Promise<TopServiceOrderListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <TopServiceOrderListModel>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopServiceOrderListModel>(<any>null);
    }

    /**
     * @return Success
     */
    getTop10DealerStall(): Promise<TopServiceOrderListModel> {
        let url_ = this.baseUrl + "/api/v1/dashboard-cms-stall/get-dealer-order";

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTop10DealerStall(_response);
        });
    }

    protected processGetTop10DealerStall(response: Response): Promise<TopServiceOrderListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <TopServiceOrderListModel>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopServiceOrderListModel>(<any>null);
    }

    /**
    * @param area (optional) 
    * @param dealer (optional) 
    * @param outlet (optional)
    * @param fromDate (optional) 
    * @param toDate (optional) 
    * @return Success
    */
    getStallChartData(area: string | null | undefined, dealer: string | null | undefined, outlet: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<DashboardChartDataModel> {
        let url_ = this.baseUrl + "/api/v1/dashboard-cms-stall/get-stall-chart-data?";
        if (area !== undefined && area !== null)
            url_ += "Area=" + encodeURIComponent("" + area) + "&";
        if (dealer !== undefined && dealer !== null)
            url_ += "Dealer=" + encodeURIComponent("" + dealer) + "&";
        if (outlet !== undefined && outlet !== null)
            url_ += "Outlet=" + encodeURIComponent("" + outlet) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toLocaleString() : "") + "&";

        url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toLocaleString() : "" + new Date().toLocaleString()) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStallChartData(_response);
        });
    }

    protected processGetStallChartData(response: Response): Promise<DashboardChartDataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <DashboardChartDataModel>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardChartDataModel>(<any>null);
    }

    /**
     * @param q (optional) 
     * @return Success
     */
    getCarSeriesDropdown(q?: string | null | undefined): Promise<GuidDropdownModel[]> {
        let url_ = this.baseUrl + "/api/v1/dropdown/series?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCarSeriesDropdown(_response);
        });
    }

    protected processGetCarSeriesDropdown(response: Response): Promise<GuidDropdownModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GuidDropdownModel[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuidDropdownModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getCarSeriesTypeDropdown(): Promise<Int32DropdownModel[]> {
        let url_ = this.baseUrl + "/api/v1/dropdown/series-type";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCarSeriesTypeDropdown(_response);
        });
    }

    protected processGetCarSeriesTypeDropdown(response: Response): Promise<Int32DropdownModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Int32DropdownModel[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Int32DropdownModel[]>(null as any);
    }

    /**
     * @param q (optional) 
     * @return Success
     */
    getInstalmentPartnersDropdown(q?: string | null | undefined): Promise<GuidDropdownModel[]> {
        let url_ = this.baseUrl + "/api/v1/dropdown/instalment-partner?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInstalmentPartnersDropdown(_response);
        });
    }

    protected processGetInstalmentPartnersDropdown(response: Response): Promise<GuidDropdownModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GuidDropdownModel[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuidDropdownModel[]>(null as any);
    }

    /**
     * @param q (optional) 
     * @return Success
     */
    getProvinceDropdown(q?: string | null | undefined): Promise<GuidDropdownModel[]> {
        let url_ = this.baseUrl + "/api/v1/dropdown/province?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProvinceDropdown(_response);
        });
    }

    protected processGetProvinceDropdown(response: Response): Promise<GuidDropdownModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GuidDropdownModel[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuidDropdownModel[]>(null as any);
    }

    /**
     * @param q (optional) 
     * @param provinceCode (optional) 
     * @return Success
     */
    getCityDropdown(q?: string | null | undefined, provinceCode?: string | null | undefined): Promise<GuidDropdownModel[]> {
        let url_ = this.baseUrl + "/api/v1/dropdown/city?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (provinceCode !== undefined && provinceCode !== null)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCityDropdown(_response);
        });
    }

    protected processGetCityDropdown(response: Response): Promise<GuidDropdownModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GuidDropdownModel[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuidDropdownModel[]>(null as any);
    }

    /**
     * @param description (optional) 
     * @return Success
     */
    getDosVariantDropdown(description?: string | null | undefined): Promise<StringDropdownModel[]> {
        let url_ = this.baseUrl + "/api/v1/dropdown/dos-variant?";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDosVariantDropdown(_response);
        });
    }

    protected processGetDosVariantDropdown(response: Response): Promise<StringDropdownModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringDropdownModel[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringDropdownModel[]>(null as any);
    }

    /**
     * @param q (optional) 
     * @return Success
     */
    getDealerDropdown(q?: string | null | undefined): Promise<StringDropdownModel[]> {
        let url_ = this.baseUrl + "/api/v1/dropdown/dealer?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDealerDropdown(_response);
        });
    }

    protected processGetDealerDropdown(response: Response): Promise<StringDropdownModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringDropdownModel[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringDropdownModel[]>(null as any);
    }

    /**
     * @param q (optional) 
     * @return Success
     */
    getOutletDropdown(q?: string | null | undefined): Promise<StringDropdownModel[]> {
        let url_ = this.baseUrl + "/api/v1/dropdown/outlet?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOutletDropdown(_response);
        });
    }

    protected processGetOutletDropdown(response: Response): Promise<StringDropdownModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringDropdownModel[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringDropdownModel[]>(null as any);
    }

    /**
     * @param q (optional) 
     * @return Success
     */
    getAreaDropdown(q?: string | null | undefined): Promise<StringDropdownModel[]> {
        let url_ = this.baseUrl + "/api/v1/dropdown/area?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAreaDropdown(_response);
        });
    }

    protected processGetAreaDropdown(response: Response): Promise<StringDropdownModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringDropdownModel[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringDropdownModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertEmailEscalationConfig(body?: CreateEmailEscalationConfigModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/email-escalation-config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertEmailEscalationConfig(_response);
        });
    }

    protected processInsertEmailEscalationConfig(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param page (optional) 
     * @param perPage (optional) 
     * @param email (optional) 
     * @param isTo (optional) 
     * @return Success
     */
    getEmailEscalationConfigs(page?: number | undefined, perPage?: number | undefined, email?: string | null | undefined, isTo?: boolean | null | undefined): Promise<EmailEscalationConfigListItemDataGrid> {
        let url_ = this.baseUrl + "/api/v1/email-escalation-config?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (isTo !== undefined && isTo !== null)
            url_ += "isTo=" + encodeURIComponent("" + isTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmailEscalationConfigs(_response);
        });
    }

    protected processGetEmailEscalationConfigs(response: Response): Promise<EmailEscalationConfigListItemDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailEscalationConfigListItemDataGrid;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailEscalationConfigListItemDataGrid>(null as any);
    }

    /**
     * @param isTo (optional) 
     * @return Success
     */
    deleteEmailEscalationConfig(email: string | null, isTo?: boolean | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/email-escalation-config/{email}?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        if (isTo === null)
            throw new Error("The parameter 'isTo' cannot be null.");
        else if (isTo !== undefined)
            url_ += "isTo=" + encodeURIComponent("" + isTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteEmailEscalationConfig(_response);
        });
    }

    protected processDeleteEmailEscalationConfig(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param q (optional) 
     * @return Success
     */
    getEmailDropdown(q?: string | null | undefined): Promise<StringDropdownModel[]> {
        let url_ = this.baseUrl + "/api/v1/email-escalation-config/email-dropdown?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmailDropdown(_response);
        });
    }

    protected processGetEmailDropdown(response: Response): Promise<StringDropdownModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringDropdownModel[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringDropdownModel[]>(null as any);
    }

    /**
     * @param page (optional) 
     * @param perPage (optional) 
     * @param status (optional) 
     * @param variantId (optional) 
     * @param modelId (optional) 
     * @param seriesId (optional) 
     * @return Success
     */
    getFaqs(page?: number | undefined, perPage?: number | undefined, status?: boolean | null | undefined, variantId?: string | null | undefined, modelId?: string | null | undefined, seriesId?: string | null | undefined): Promise<FaqDataGrid> {
        let url_ = this.baseUrl + "/api/v1/faq?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (variantId !== undefined && variantId !== null)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&";
        if (modelId !== undefined && modelId !== null)
            url_ += "modelId=" + encodeURIComponent("" + modelId) + "&";
        if (seriesId !== undefined && seriesId !== null)
            url_ += "seriesId=" + encodeURIComponent("" + seriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFaqs(_response);
        });
    }

    protected processGetFaqs(response: Response): Promise<FaqDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FaqDataGrid;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FaqDataGrid>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertFaq(body?: CreateFaqModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/faq";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertFaq(_response);
        });
    }

    protected processInsertFaq(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getFaqDetails(id: string): Promise<FaqDetailView> {
        let url_ = this.baseUrl + "/api/v1/faq/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFaqDetails(_response);
        });
    }

    protected processGetFaqDetails(response: Response): Promise<FaqDetailView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FaqDetailView;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FaqDetailView>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editFaq(id: string, body?: EditFaqModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/faq/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditFaq(_response);
        });
    }

    protected processEditFaq(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    deleteFaq(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/faq/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteFaq(_response);
        });
    }

    protected processDeleteFaq(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getGeneralDashboardData(): Promise<GeneralDashboardModel> {
        let url_ = this.baseUrl + "/api/v1/general-dashboard";

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGeneralDashboardData(_response);
        });
    }

    protected processGetGeneralDashboardData(response: Response): Promise<GeneralDashboardModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <CarSeriesDetailViewModel>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GeneralDashboardModel>(<any>null);
    }

    /**
    * @param area (optional) 
    * @param dealer (optional) 
    * @param outlet (optional)
    * @param fromDate (optional) 
    * @param toDate (optional) 
    * @return Success
    */
    getServicePercentage(area: string | null | undefined, dealer: string | null | undefined, outlet: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<GeneralServicePercentageModel> {
        let url_ = this.baseUrl + "/api/v1/general-dashboard/service-percentage?";
        if (area !== undefined && area !== null)
            url_ += "Area=" + encodeURIComponent("" + area) + "&";
        if (dealer !== undefined && dealer !== null)
            url_ += "Dealer=" + encodeURIComponent("" + dealer) + "&";
        if (outlet !== undefined && outlet !== null)
            url_ += "Outlet=" + encodeURIComponent("" + outlet) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toLocaleString() : "") + "&";

        url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toLocaleString() : "" + new Date().toLocaleString()) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetServicePercentage(_response);
        });
    }

    protected processGetServicePercentage(response: Response): Promise<GeneralServicePercentageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <GeneralServicePercentageModel>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GeneralServicePercentageModel>(<any>null);
    }

    /**
     * @param page (optional) 
     * @param query (optional) 
     * @param tagId (optional) 
     * @param date (optional) 
     * @return Success
     */
    getHighlights(page?: number | undefined, query?: string | null | undefined, tagId?: number | null | undefined, date?: Date | null | undefined): Promise<NewsDataGrid> {
        let url_ = this.baseUrl + "/api/v1/highlight?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (tagId !== undefined && tagId !== null)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHighlights(_response);
        });
    }

    protected processGetHighlights(response: Response): Promise<NewsDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewsDataGrid;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsDataGrid>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertHighlight(body?: CreateOrUpdateNewsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/highlight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertHighlight(_response);
        });
    }

    protected processInsertHighlight(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getHighlightDetail(id: string): Promise<NewsDetailModelCms> {
        let url_ = this.baseUrl + "/api/v1/highlight/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHighlightDetail(_response);
        });
    }

    protected processGetHighlightDetail(response: Response): Promise<NewsDetailModelCms> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewsDetailModelCms;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsDetailModelCms>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editHighlight(id: string, body?: CreateOrUpdateNewsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/highlight/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditHighlight(_response);
        });
    }

    protected processEditHighlight(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteHighlight(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/highlight/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteHighlight(_response);
        });
    }

    protected processDeleteHighlight(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    publishHighlight(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/highlight/{id}/publish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishHighlight(_response);
        });
    }

    protected processPublishHighlight(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    unpublishHighlight(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/highlight/{id}/unpublish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishHighlight(_response);
        });
    }

    protected processUnpublishHighlight(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param q (optional) 
     * @return Success
     */
    getNewsHighlightTagDropdown(q?: string | null | undefined): Promise<DropdownListItem[]> {
        let url_ = this.baseUrl + "/api/v1/highlight/dropdown?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewsHighlightTagDropdown(_response);
        });
    }

    protected processGetNewsHighlightTagDropdown(response: Response): Promise<DropdownListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DropdownListItem[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DropdownListItem[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertInstalmentPackage(body?: CreateEditInstalmentPackageModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/instalment-package";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertInstalmentPackage(_response);
        });
    }

    protected processInsertInstalmentPackage(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param page (optional) 
     * @param perPage (optional) 
     * @param leasingPartnerId (optional) 
     * @param provinceCode (optional) 
     * @return Success
     */
    getInstalmentPackages(page?: number | undefined, perPage?: number | undefined, leasingPartnerId?: string | null | undefined, provinceCode?: string | null | undefined): Promise<InstalmentPackageListItemDataGrid> {
        let url_ = this.baseUrl + "/api/v1/instalment-package?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (leasingPartnerId !== undefined && leasingPartnerId !== null)
            url_ += "leasingPartnerId=" + encodeURIComponent("" + leasingPartnerId) + "&";
        if (provinceCode !== undefined && provinceCode !== null)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInstalmentPackages(_response);
        });
    }

    protected processGetInstalmentPackages(response: Response): Promise<InstalmentPackageListItemDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstalmentPackageListItemDataGrid;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstalmentPackageListItemDataGrid>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInstalmentPackage(id: string, body?: CreateEditInstalmentPackageModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/instalment-package/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateInstalmentPackage(_response);
        });
    }

    protected processUpdateInstalmentPackage(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    deleteInstalmentPackage(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/instalment-package/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInstalmentPackage(_response);
        });
    }

    protected processDeleteInstalmentPackage(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getInstalmentPackage(id: string): Promise<InstalmentPackageDetailView> {
        let url_ = this.baseUrl + "/api/v1/instalment-package/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInstalmentPackage(_response);
        });
    }

    protected processGetInstalmentPackage(response: Response): Promise<InstalmentPackageDetailView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstalmentPackageDetailView;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstalmentPackageDetailView>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertInstalmentPartner(body?: CreateEditInstalmentPartnerModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/instalment-partner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertInstalmentPartner(_response);
        });
    }

    protected processInsertInstalmentPartner(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param page (optional) 
     * @param perPage (optional) 
     * @param id (optional) 
     * @return Success
     */
    getInstalmentPartners(page?: number | undefined, perPage?: number | undefined, id?: string | null | undefined): Promise<InstalmentPartnerListItemDataGrid> {
        let url_ = this.baseUrl + "/api/v1/instalment-partner?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInstalmentPartners(_response);
        });
    }

    protected processGetInstalmentPartners(response: Response): Promise<InstalmentPartnerListItemDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstalmentPartnerListItemDataGrid;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstalmentPartnerListItemDataGrid>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInstalmentPartner(id: string, body?: CreateEditInstalmentPartnerModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/instalment-partner/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateInstalmentPartner(_response);
        });
    }

    protected processUpdateInstalmentPartner(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    deleteInstalmentPartner(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/instalment-partner/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInstalmentPartner(_response);
        });
    }

    protected processDeleteInstalmentPartner(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getInstalmentPartner(id: string): Promise<InstalmentPartnerDetailView> {
        let url_ = this.baseUrl + "/api/v1/instalment-partner/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInstalmentPartner(_response);
        });
    }

    protected processGetInstalmentPartner(response: Response): Promise<InstalmentPartnerDetailView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstalmentPartnerDetailView;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstalmentPartnerDetailView>(null as any);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getMobileAppsRoleNames(skip?: number | undefined, take?: number | undefined): Promise<RolePageMappingGridDataModel> {
        let url_ = this.baseUrl + "/api/v1/MobileAppRolePageMapping?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMobileAppsRoleNames(_response);
        });
    }

    protected processGetMobileAppsRoleNames(response: Response): Promise<RolePageMappingGridDataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RolePageMappingGridDataModel;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RolePageMappingGridDataModel>(null as any);
    }

    /**
     * @return Success
     */
    getMobileAppsRolePageMapping(id: number): Promise<RolePageMappingFormModel> {
        let url_ = this.baseUrl + "/api/v1/MobileAppRolePageMapping/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMobileAppsRolePageMapping(_response);
        });
    }

    protected processGetMobileAppsRolePageMapping(response: Response): Promise<RolePageMappingFormModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RolePageMappingFormModel;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RolePageMappingFormModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMobileAppsRolePageMapping(id: number, body?: RolePageMappingModel[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MobileAppRolePageMapping/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveMobileAppsRolePageMapping(_response);
        });
    }

    protected processSaveMobileAppsRolePageMapping(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param query (optional) 
     * @param tagId (optional) 
     * @param date (optional) 
     * @return Success
     */
    getNews(page?: number | undefined, query?: string | null | undefined, tagId?: number | null | undefined, date?: Date | null | undefined): Promise<NewsDataGrid> {
        let url_ = this.baseUrl + "/api/v1/news?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (tagId !== undefined && tagId !== null)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNews(_response);
        });
    }

    protected processGetNews(response: Response): Promise<NewsDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewsDataGrid;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsDataGrid>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertNews(body?: CreateOrUpdateNewsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/news";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertNews(_response);
        });
    }

    protected processInsertNews(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getNewsDetail(id: string): Promise<NewsDetailModelCms> {
        let url_ = this.baseUrl + "/api/v1/news/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewsDetail(_response);
        });
    }

    protected processGetNewsDetail(response: Response): Promise<NewsDetailModelCms> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewsDetailModelCms;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsDetailModelCms>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editNews(id: string, body?: CreateOrUpdateNewsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/news/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditNews(_response);
        });
    }

    protected processEditNews(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteNews(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/news/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteNews(_response);
        });
    }

    protected processDeleteNews(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    publishNews(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/news/{id}/publish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishNews(_response);
        });
    }

    protected processPublishNews(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    unpublishNews(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/news/{id}/unpublish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishNews(_response);
        });
    }

    protected processUnpublishNews(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    logout(): Promise<void> {
        let url_ = this.baseUrl + "/Oidc/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    token(): Promise<void> {
        let url_ = this.baseUrl + "/Oidc/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToken(_response);
        });
    }

    protected processToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    authorizeGET(): Promise<void> {
        let url_ = this.baseUrl + "/Oidc/authorize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorizeGET(_response);
        });
    }

    protected processAuthorizeGET(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    authorizePOST(): Promise<void> {
        let url_ = this.baseUrl + "/Oidc/authorize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorizePOST(_response);
        });
    }

    protected processAuthorizePOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    userinfo(): Promise<void> {
        let url_ = this.baseUrl + "/Oidc/userinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserinfo(_response);
        });
    }

    protected processUserinfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param dealer (optional) 
     * @param outlet (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    getReportReferralCodes(
        page: number | undefined,
        dealer: string | null | undefined,
        outlet: string | null | undefined,
        users: string | null | undefined,
        fromDate: Date | null | undefined,
        toDate: Date | null | undefined
    ): Promise<ReportReferralCodeDataGrid> {
        let url_ = this.baseUrl + "/api/v1/report-referral-code?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (outlet !== undefined && outlet !== null)
            url_ += "outlet=" + encodeURIComponent("" + outlet) + "&";
        if (dealer !== undefined && dealer !== null)
            url_ += "dealer=" + encodeURIComponent("" + dealer) + "&";
        if (users !== undefined && users !== null)
            url_ += "users=" + encodeURIComponent("" + users) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReportReferralCodes(_response);
        });
    }

    protected processGetReportReferralCodes(response: Response): Promise<ReportReferralCodeDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ReportReferralCodeDataGrid>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportReferralCodeDataGrid>(<any>null);
    }

    /**
     * @param dealer (optional) 
     * @param outlet (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    downloadReportReferralCodes(
        dealer: string | null | undefined,
        outlet: string | null | undefined,
        users: string | null | undefined,
        fromDate: Date | null | undefined,
        toDate: Date | null | undefined
    ): Promise<DownloadReportReferralCode> {
        let url_ = this.baseUrl + "/api/v1/report-referral-code/download?";
        if (outlet !== undefined && outlet !== null)
            url_ += "outlet=" + encodeURIComponent("" + outlet) + "&";
        if (dealer !== undefined && dealer !== null)
            url_ += "dealer=" + encodeURIComponent("" + dealer) + "&";
        if (users !== undefined && users !== null)
            url_ += "users=" + encodeURIComponent("" + users) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadReportReferralCodes(_response);
        });
    }

    protected processDownloadReportReferralCodes(response: Response): Promise<DownloadReportReferralCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <DownloadReportReferralCode>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadReportReferralCode>(<any>null);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getRoleNames(skip?: number | undefined, take?: number | undefined): Promise<RolePageMappingGridDataModel> {
        let url_ = this.baseUrl + "/api/v1/RolePageMapping?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoleNames(_response);
        });
    }

    protected processGetRoleNames(response: Response): Promise<RolePageMappingGridDataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RolePageMappingGridDataModel;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RolePageMappingGridDataModel>(null as any);
    }

    /**
     * @return Success
     */
    getRolePageMapping(id: number): Promise<RolePageMappingFormModel> {
        let url_ = this.baseUrl + "/api/v1/RolePageMapping/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRolePageMapping(_response);
        });
    }

    protected processGetRolePageMapping(response: Response): Promise<RolePageMappingFormModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RolePageMappingFormModel;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RolePageMappingFormModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveRolePageMapping(id: number, body?: RolePageMappingModel[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/RolePageMapping/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveRolePageMapping(_response);
        });
    }

    protected processSaveRolePageMapping(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getCmsMenu(): Promise<number[]> {
        let url_ = this.baseUrl + "/api/v1/RolePageMapping/cms-menu";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCmsMenu(_response);
        });
    }

    protected processGetCmsMenu(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * @param pageId (optional) 
     * @return Success
     */
    getAccessMenu(pageId?: number | undefined): Promise<RolePageMappingAccessModel> {
        let url_ = this.baseUrl + "/api/v1/RolePageMapping/cms-access-menu?";
        if (pageId === null)
            throw new Error("The parameter 'pageId' cannot be null.");
        else if (pageId !== undefined)
            url_ += "pageId=" + encodeURIComponent("" + pageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccessMenu(_response);
        });
    }

    protected processGetAccessMenu(response: Response): Promise<RolePageMappingAccessModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RolePageMappingAccessModel;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RolePageMappingAccessModel>(null as any);
    }

    /**
     * @param query (optional) 
     * @param modelCode (optional) 
     * @return Success
     */
    getUnitFilterSearch(query?: string | null | undefined, modelCode?: string | null | undefined): Promise<CarVariantListItem[]> {
        let url_ = this.baseUrl + "/api/v1/unit/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (modelCode !== undefined && modelCode !== null)
            url_ += "modelCode=" + encodeURIComponent("" + modelCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnitFilterSearch(_response);
        });
    }

    protected processGetUnitFilterSearch(response: Response): Promise<CarVariantListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CarVariantListItem[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarVariantListItem[]>(null as any);
    }

    /**
     * @param search (optional) 
     * @param seriesId (optional) 
     * @param page (optional) 
     * @param perPage (optional) 
     * @param modelId (optional) 
     * @return Success
     */
    getCatalogUnit(search?: string | null | undefined, seriesId?: string | null | undefined, page?: number | undefined, perPage?: number | undefined, modelId?: string | null | undefined): Promise<CatalogUnitDataGridModel> {
        let url_ = this.baseUrl + "/api/v1/unit?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (seriesId !== undefined && seriesId !== null)
            url_ += "seriesId=" + encodeURIComponent("" + seriesId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (modelId !== undefined && modelId !== null)
            url_ += "modelId=" + encodeURIComponent("" + modelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCatalogUnit(_response);
        });
    }

    protected processGetCatalogUnit(response: Response): Promise<CatalogUnitDataGridModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogUnitDataGridModel;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogUnitDataGridModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertUnitCatalog(body?: CreateCatalogUnitModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/unit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertUnitCatalog(_response);
        });
    }

    protected processInsertUnitCatalog(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    deleteUnitCatalog(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/unit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUnitCatalog(_response);
        });
    }

    protected processDeleteUnitCatalog(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editCatalogUnit(id: string, body?: EditCatalogUnitModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/unit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditCatalogUnit(_response);
        });
    }

    protected processEditCatalogUnit(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getCatalogUnitDetail(id: string): Promise<CatalogUnitDetailViewModel> {
        let url_ = this.baseUrl + "/api/v1/unit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCatalogUnitDetail(_response);
        });
    }

    protected processGetCatalogUnitDetail(response: Response): Promise<CatalogUnitDetailViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogUnitDetailViewModel;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogUnitDetailViewModel>(null as any);
    }

    /**
     * @param seriesId (optional) 
     * @return Success
     */
    getSpecificationsUnit(seriesId?: string | undefined): Promise<CatalogUnitSpecificationModel[]> {
        let url_ = this.baseUrl + "/api/v1/unit/Specification?";
        if (seriesId === null)
            throw new Error("The parameter 'seriesId' cannot be null.");
        else if (seriesId !== undefined)
            url_ += "seriesId=" + encodeURIComponent("" + seriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpecificationsUnit(_response);
        });
    }

    protected processGetSpecificationsUnit(response: Response): Promise<CatalogUnitSpecificationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogUnitSpecificationModel[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogUnitSpecificationModel[]>(null as any);
    }

    /**
     * @param seriesTypeId (optional) 
     * @return Success
     */
    getUnitComparisonConfigs(seriesTypeId?: number | undefined): Promise<UnitComparisonConfigListItem[]> {
        let url_ = this.baseUrl + "/api/v1/unit-comparison?";
        if (seriesTypeId === null)
            throw new Error("The parameter 'seriesTypeId' cannot be null.");
        else if (seriesTypeId !== undefined)
            url_ += "seriesTypeId=" + encodeURIComponent("" + seriesTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnitComparisonConfigs(_response);
        });
    }

    protected processGetUnitComparisonConfigs(response: Response): Promise<UnitComparisonConfigListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnitComparisonConfigListItem[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitComparisonConfigListItem[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUnitComparisonConfigs(body?: EditUnitComparisonConfigModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/unit-comparison/UpdateUnitComparisonConfigs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUnitComparisonConfigs(_response);
        });
    }

    protected processUpdateUnitComparisonConfigs(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertUnitSpecificationIndicators(body?: CreateEditSpecificationIndicatorModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/unit-specification-indicator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertUnitSpecificationIndicators(_response);
        });
    }

    protected processInsertUnitSpecificationIndicators(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param searchQuery (optional) 
     * @param specId (optional) 
     * @param carSeriesTypeId (optional) 
     * @param page (optional) 
     * @param perPage (optional) 
     * @return Success
     */
    getUnitSpecificationIndicators(searchQuery?: string | null | undefined, specId?: number | null | undefined, carSeriesTypeId?: number | null | undefined, page?: number | undefined, perPage?: number | undefined): Promise<SpecificationIndicatorDataGrid> {
        let url_ = this.baseUrl + "/api/unit-specification-indicator?";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (specId !== undefined && specId !== null)
            url_ += "specId=" + encodeURIComponent("" + specId) + "&";
        if (carSeriesTypeId !== undefined && carSeriesTypeId !== null)
            url_ += "carSeriesTypeId=" + encodeURIComponent("" + carSeriesTypeId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnitSpecificationIndicators(_response);
        });
    }

    protected processGetUnitSpecificationIndicators(response: Response): Promise<SpecificationIndicatorDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpecificationIndicatorDataGrid;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpecificationIndicatorDataGrid>(null as any);
    }

    /**
     * @return Success
     */
    getUnitSpecificationIndicatorDetail(id: number): Promise<SpecificationIndicatorDetailView> {
        let url_ = this.baseUrl + "/api/unit-specification-indicator/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnitSpecificationIndicatorDetail(_response);
        });
    }

    protected processGetUnitSpecificationIndicatorDetail(response: Response): Promise<SpecificationIndicatorDetailView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpecificationIndicatorDetailView;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpecificationIndicatorDetailView>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editUnitSpecificationIndicator(id: number, body?: CreateEditSpecificationIndicatorModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/unit-specification-indicator/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditUnitSpecificationIndicator(_response);
        });
    }

    protected processEditUnitSpecificationIndicator(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    deleteUnitSpecificationIndicator(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/unit-specification-indicator/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUnitSpecificationIndicator(_response);
        });
    }

    protected processDeleteUnitSpecificationIndicator(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param searchQuery (optional) 
     * @return Success
     */
    getSpecificationDropdown(searchQuery?: string | null | undefined): Promise<UnitSpecificationListItem[]> {
        let url_ = this.baseUrl + "/api/unit-specification-indicator/spec-dropdown?";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpecificationDropdown(_response);
        });
    }

    protected processGetSpecificationDropdown(response: Response): Promise<UnitSpecificationListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnitSpecificationListItem[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitSpecificationListItem[]>(null as any);
    }

    /**
     * @param typeId (optional) 
     * @param categoryId (optional) 
     * @param unitId (optional) 
     * @param page (optional) 
     * @param perPage (optional) 
     * @return Success
     */
    getUnitSuggestions(typeId?: number | null | undefined, categoryId?: string | null | undefined, unitId?: string | null | undefined, page?: number | undefined, perPage?: number | undefined): Promise<UnitSuggestionDataGrid> {
        let url_ = this.baseUrl + "/api/v1/unit-suggestion?";
        if (typeId !== undefined && typeId !== null)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (unitId !== undefined && unitId !== null)
            url_ += "UnitId=" + encodeURIComponent("" + unitId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnitSuggestions(_response);
        });
    }

    protected processGetUnitSuggestions(response: Response): Promise<UnitSuggestionDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnitSuggestionDataGrid;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitSuggestionDataGrid>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertUnitSuggestions(body?: CreateUnitSuggestionModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/unit-suggestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertUnitSuggestions(_response);
        });
    }

    protected processInsertUnitSuggestions(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    deleteUnitSuggestion(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/unit-suggestion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUnitSuggestion(_response);
        });
    }

    protected processDeleteUnitSuggestion(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertSuggestinCategory(body?: CreateEditSuggestionCategoryModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/unit-suggestion-category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertSuggestinCategory(_response);
        });
    }

    protected processInsertSuggestinCategory(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param suggestionValue (optional) 
     * @param suggestionTypeId (optional) 
     * @param page (optional) 
     * @param perPage (optional) 
     * @return Success
     */
    getSuggestionCategories(suggestionValue?: string | null | undefined, suggestionTypeId?: number | null | undefined, page?: number | undefined, perPage?: number | undefined): Promise<SuggestionCategoryDataGrid> {
        let url_ = this.baseUrl + "/api/v1/unit-suggestion-category?";
        if (suggestionValue !== undefined && suggestionValue !== null)
            url_ += "suggestionValue=" + encodeURIComponent("" + suggestionValue) + "&";
        if (suggestionTypeId !== undefined && suggestionTypeId !== null)
            url_ += "suggestionTypeId=" + encodeURIComponent("" + suggestionTypeId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSuggestionCategories(_response);
        });
    }

    protected processGetSuggestionCategories(response: Response): Promise<SuggestionCategoryDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SuggestionCategoryDataGrid;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SuggestionCategoryDataGrid>(null as any);
    }

    /**
     * @return Success
     */
    getSuggestionCategoryDetail(id: string): Promise<SuggestionCategoryDetailView> {
        let url_ = this.baseUrl + "/api/v1/unit-suggestion-category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSuggestionCategoryDetail(_response);
        });
    }

    protected processGetSuggestionCategoryDetail(response: Response): Promise<SuggestionCategoryDetailView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SuggestionCategoryDetailView;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SuggestionCategoryDetailView>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editSuggestionCategory(id: string, body?: CreateEditSuggestionCategoryModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/unit-suggestion-category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditSuggestionCategory(_response);
        });
    }

    protected processEditSuggestionCategory(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    deleteSuggestionCategory(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/unit-suggestion-category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSuggestionCategory(_response);
        });
    }

    protected processDeleteSuggestionCategory(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param query (optional) 
     * @param typeId (optional) 
     * @return Success
     */
    getSuggestionCategorySearch(query?: string | null | undefined, typeId?: number | null | undefined): Promise<SuggestionCategoryDropdownModel[]> {
        let url_ = this.baseUrl + "/api/v1/unit-suggestion-category/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (typeId !== undefined && typeId !== null)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSuggestionCategorySearch(_response);
        });
    }

    protected processGetSuggestionCategorySearch(response: Response): Promise<SuggestionCategoryDropdownModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SuggestionCategoryDropdownModel[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SuggestionCategoryDropdownModel[]>(null as any);
    }

    /**
     * @param query (optional) 
     * @return Success
     */
    getSuggestionTypeSearch(query?: string | null | undefined): Promise<SuggestionTypeListItem[]> {
        let url_ = this.baseUrl + "/api/v1/unit-suggestion-type/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSuggestionTypeSearch(_response);
        });
    }

    protected processGetSuggestionTypeSearch(response: Response): Promise<SuggestionTypeListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SuggestionTypeListItem[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SuggestionTypeListItem[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertUserGuideline(body?: CreateUserGuidelineModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/user-guideline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertUserGuideline(_response);
        });
    }

    protected processInsertUserGuideline(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param page (optional) 
     * @param perPage (optional) 
     * @param userTypeId (optional) 
     * @param categoryId (optional) 
     * @param ordering (optional) 
     * @param isPublish (optional) 
     * @return Success
     */
    getUserGuidelines(page?: number | undefined, perPage?: number | undefined, userTypeId?: number | null | undefined, categoryId?: string | null | undefined, ordering?: number | null | undefined, isPublish?: boolean | null | undefined): Promise<UserGuidelineListItemDataGrid> {
        let url_ = this.baseUrl + "/api/v1/user-guideline?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (userTypeId !== undefined && userTypeId !== null)
            url_ += "userTypeId=" + encodeURIComponent("" + userTypeId) + "&";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (ordering !== undefined && ordering !== null)
            url_ += "ordering=" + encodeURIComponent("" + ordering) + "&";
        if (isPublish !== undefined && isPublish !== null)
            url_ += "isPublish=" + encodeURIComponent("" + isPublish) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserGuidelines(_response);
        });
    }

    protected processGetUserGuidelines(response: Response): Promise<UserGuidelineListItemDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGuidelineListItemDataGrid;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGuidelineListItemDataGrid>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserGuideline(id: string, body?: EditUserGuidelineModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/user-guideline/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserGuideline(_response);
        });
    }

    protected processUpdateUserGuideline(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    deleteUserGuideline(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/user-guideline/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUserGuideline(_response);
        });
    }

    protected processDeleteUserGuideline(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getUserGuidelineDetails(id: string): Promise<UserGuidelineDetailView> {
        let url_ = this.baseUrl + "/api/v1/user-guideline/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserGuidelineDetails(_response);
        });
    }

    protected processGetUserGuidelineDetails(response: Response): Promise<UserGuidelineDetailView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGuidelineDetailView;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGuidelineDetailView>(null as any);
    }

    /**
     * @param term (optional) 
     * @param userTypeId (optional) 
     * @return Success
     */
    getUserGuidelineCategoryDropdown(term?: string | null | undefined, userTypeId?: number | null | undefined): Promise<GuidDropdownModel[]> {
        let url_ = this.baseUrl + "/api/v1/user-guideline/category-dropdown?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (userTypeId !== undefined && userTypeId !== null)
            url_ += "userTypeId=" + encodeURIComponent("" + userTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserGuidelineCategoryDropdown(_response);
        });
    }

    protected processGetUserGuidelineCategoryDropdown(response: Response): Promise<GuidDropdownModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GuidDropdownModel[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuidDropdownModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertUserGuidelineCategory(body?: CreateEditUserGuidelineCategory | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/user-guideline-category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertUserGuidelineCategory(_response);
        });
    }

    protected processInsertUserGuidelineCategory(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param term (optional) 
     * @param userTypeId (optional) 
     * @param ordering (optional) 
     * @param page (optional) 
     * @param perPage (optional) 
     * @return Success
     */
    getUserGuidelineCategories(term?: string | null | undefined, userTypeId?: number | null | undefined, ordering?: number | null | undefined, page?: number | undefined, perPage?: number | undefined): Promise<UserGuidelineCategoryListItemDataGrid> {
        let url_ = this.baseUrl + "/api/v1/user-guideline-category?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (userTypeId !== undefined && userTypeId !== null)
            url_ += "userTypeId=" + encodeURIComponent("" + userTypeId) + "&";
        if (ordering !== undefined && ordering !== null)
            url_ += "ordering=" + encodeURIComponent("" + ordering) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserGuidelineCategories(_response);
        });
    }

    protected processGetUserGuidelineCategories(response: Response): Promise<UserGuidelineCategoryListItemDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGuidelineCategoryListItemDataGrid;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGuidelineCategoryListItemDataGrid>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserGuidelineCategory(id: string, body?: CreateEditUserGuidelineCategory | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/user-guideline-category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserGuidelineCategory(_response);
        });
    }

    protected processUpdateUserGuidelineCategory(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    deleteUserGuidelineCategory(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/user-guideline-category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUserGuidelineCategory(_response);
        });
    }

    protected processDeleteUserGuidelineCategory(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getUserGuidelineCategoryDetails(id: string): Promise<UserGuidelineCategoryDetailView> {
        let url_ = this.baseUrl + "/api/v1/user-guideline-category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserGuidelineCategoryDetails(_response);
        });
    }

    protected processGetUserGuidelineCategoryDetails(response: Response): Promise<UserGuidelineCategoryDetailView> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGuidelineCategoryDetailView;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGuidelineCategoryDetailView>(null as any);
    }

    /**
     * @return Success
     */
    getUserTypeDropdown(): Promise<Int32DropdownModel[]> {
        let url_ = this.baseUrl + "/api/v1/user-guideline-category/user-type-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserTypeDropdown(_response);
        });
    }

    protected processGetUserTypeDropdown(response: Response): Promise<Int32DropdownModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Int32DropdownModel[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Int32DropdownModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertNewUser(body?: UserRegistrationFormModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/user-registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertNewUser(_response);
        });
    }

    protected processInsertNewUser(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param email (optional) 
     * @param nPK (optional) 
     * @param accessRole (optional) 
     * @param page (optional) 
     * @return Success
     */
    getUserRoleMappings(email?: string | null | undefined, nPK?: string | null | undefined, accessRole?: number | null | undefined, page?: number | undefined): Promise<UserRoleMappingDataGrid> {
        let url_ = this.baseUrl + "/api/v1/user-role-mapping?";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (nPK !== undefined && nPK !== null)
            url_ += "NPK=" + encodeURIComponent("" + nPK) + "&";
        if (accessRole !== undefined && accessRole !== null)
            url_ += "AccessRole=" + encodeURIComponent("" + accessRole) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserRoleMappings(_response);
        });
    }

    protected processGetUserRoleMappings(response: Response): Promise<UserRoleMappingDataGrid> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserRoleMappingDataGrid;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserRoleMappingDataGrid>(null as any);
    }

    /**
     * @return Success
     */
    getUserRoleMappingDetail(userId: string): Promise<UserRoleMappingDetailModel> {
        let url_ = this.baseUrl + "/api/v1/user-role-mapping/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserRoleMappingDetail(_response);
        });
    }

    protected processGetUserRoleMappingDetail(response: Response): Promise<UserRoleMappingDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserRoleMappingDetailModel;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserRoleMappingDetailModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editUserRoleMapping(userId: string, body?: UpdateUserRoleMappingModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user-role-mapping/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditUserRoleMapping(_response);
        });
    }

    protected processEditUserRoleMapping(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param q (optional) 
     * @return Success
     */
    getUserRoleDropdown(q?: string | null | undefined): Promise<DropdownListItem[]> {
        let url_ = this.baseUrl + "/api/v1/user-role-mapping/dropdown/user-roles?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserRoleDropdown(_response);
        });
    }

    protected processGetUserRoleDropdown(response: Response): Promise<DropdownListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DropdownListItem[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DropdownListItem[]>(null as any);
    }

    /**
     * @param q (optional) 
     * @return Success
     */
    getEmailsDropdown(q?: string | null | undefined): Promise<DropdownListItem[]> {
        let url_ = this.baseUrl + "/api/v1/user-role-mapping/dropdown/email?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmailsDropdown(_response);
        });
    }

    protected processGetEmailsDropdown(response: Response): Promise<DropdownListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DropdownListItem[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DropdownListItem[]>(null as any);
    }

    /**
     * @param q (optional) 
     * @return Success
     */
    getNPKDropdown(q?: string | null | undefined): Promise<DropdownListItem[]> {
        let url_ = this.baseUrl + "/api/v1/user-role-mapping/dropdown/npk?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNPKDropdown(_response);
        });
    }

    protected processGetNPKDropdown(response: Response): Promise<DropdownListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DropdownListItem[];
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DropdownListItem[]>(null as any);
    }
}

export interface PreSignedUrlModel {
    preSignedUrl: string | null;
}

export interface CarModelListItemCms {
    modelId: string;
    seriesName: string | null;
    name: string | null;
    isPublish: boolean | null;
}

export interface CarModelDataGrid {
    totalItems: number;
    totalPages: number;
    items: CarModelListItemCms[] | null;
}

export interface FileUploadMeta {
    fileId: string;
    fileName: string;
    contentType: string;
}

export interface CreateCarFeatureModel {
    name: string;
    image: FileUploadMeta;
}

export interface CreateCarModel {
    seriesId: string;
    name: string;
    image: FileUploadMeta;
    carFeatures: CreateCarFeatureModel[];
    createdBy: string | null;
    isPublish: boolean;
}

export interface CarFeatureDetailView {
    id: string;
    name: string | null;
    fileId: string;
    fileName: string | null;
    fileType: string | null;
}

export interface CarModelDetailView {
    carModelId: string;
    carSeriesName: string | null;
    carSeriesId: string;
    blobId: string;
    carModelName: string | null;
    fileName: string | null;
    fileType: string | null;
    isPublish: boolean | null;
    carFeatures: CarFeatureDetailView[] | null;
}

export interface EditCarFeatureModel {
    id: string | null;
    name: string;
    image: FileUploadMeta;
}

export interface EditCarModel {
    image: FileUploadMeta;
    carFeatures: EditCarFeatureModel[];
    updatedBy: string | null;
    isPublish: boolean;
}

export interface CarModelListItem {
    modelId: string | null;
    name: string | null;
}

export interface CarModelGalleryModel {
    imageTitle: string | null;
    imageFile: FileUploadMeta;
}

export interface CarModelTestimonyDisplayModel {
    id: string | null;
    customerName: string | null;
    customerTestimony: string | null;
}

export interface CarModelDetailV2View {
    carModelId: string;
    carSeriesName: string | null;
    carSeriesId: string;
    blobId: string;
    carModelName: string | null;
    fileName: string | null;
    fileType: string | null;
    isPublish: boolean | null;
    carGalleries: CarModelGalleryModel[] | null;
    carTestimonies: CarModelTestimonyDisplayModel[] | null;
}

export interface CarModelTestimonyModel {
    customerName: string | null;
    customerTestimony: string | null;
}

export interface EditCarModelV2 {
    image: FileUploadMeta;
    carGalleries: CarModelGalleryModel[] | null;
    carTestimonies: CarModelTestimonyModel[] | null;
    updatedBy: string | null;
    isPublish: boolean;
}

export interface CreateCarModelV2Model {
    seriesId: string;
    name: string;
    image: FileUploadMeta;
    listOfCarGalleries: CarModelGalleryModel[] | null;
    listOfTestimonies: CarModelTestimonyModel[] | null;
    createdBy: string | null;
    isPublish: boolean;
}

export interface CreateEditCarSeriesModel {
    typeId: number;
    name: string;
    image: FileUploadMeta;
    createdOrUpdatedBy: string | null;
}

export interface CarSeriesListItem {
    id: string;
    name: string | null;
    type: string | null;
}

export interface CarSeriesListItemDataGrid {
    totalItems: number;
    totalPages: number;
    items: CarSeriesListItem[] | null;
}

export interface CarSeriesDetailViewModel {
    typeId: number;
    typeName: string | null;
    seriesName: string | null;
    fileId: string;
    fileName: string | null;
    contentType: string | null;
}

export interface TopServiceOrderListModel {
    data: TopServiceOrderModel[]
}

export interface TopServiceOrderModel {
    name: string;
    serviceCount: string;
}

export interface GuidDropdownModel {
    label: string | null;
    value: string;
}

export interface Int32DropdownModel {
    label: string | null;
    value: number;
}

export interface StringDropdownModel {
    label: string | null;
    value: string | null;
}

export interface CreateEmailEscalationConfigModel {
    email: string;
    isTo: boolean;
    createdBy: string | null;
}

export interface EmailEscalationConfigListItem {
    email: string | null;
    isTo: boolean;
}

export interface EmailEscalationConfigListItemDataGrid {
    totalItems: number;
    totalPages: number;
    items: EmailEscalationConfigListItem[] | null;
}

export interface FaqCmsListItem {
    faqId: string;
    seriesName: string | null;
    modelName: string | null;
    variantName: string | null;
    question: string | null;
    answer: string | null;
    status: string | null;
}

export interface FaqDataGrid {
    totalItems: number;
    totalPages: number;
    items: FaqCmsListItem[] | null;
}

export interface CreateFaqDetailModel {
    question: string;
    answer: string;
    isPublish: boolean;
}

export interface CreateFaqModel {
    variantId: string;
    faqDetails: CreateFaqDetailModel[];
    createdBy: string | null;
}

export interface FaqDetailView {
    seriesName: string | null;
    modelName: string | null;
    variantName: string | null;
    question: string | null;
    answer: string | null;
    isPublish: boolean;
}

export interface EditFaqModel {
    question: string;
    answer: string;
    isPublish: boolean;
    updatedBy: string | null;
}

export interface GetServicePercentageRequest {
    area: string | null;
    dealer: string | null;
    outlet: string | null;
    fromDate: Date | null;
    toDate: Date | null;
}

export interface NewsListItemCms {
    newsId: string;
    title: string | null;
    validFrom: Date;
    validTo: Date;
    tag: string | null;
    pushEmail: Date | null;
    pushApps: Date | null;
    pushEmailCount: number;
    pushAppsCount: number;
    publishStatus: boolean;
}

export interface NewsDataGrid {
    totalItems: number;
    totalPages: number;
    items: NewsListItemCms[] | null;
}

export interface CreateOrUpdateNewsModel {
    title: string;
    description: string;
    validFrom: Date;
    validTo: Date;
    tagId: number;
    image: FileUploadMeta;
    image2: FileUploadMeta | null;
    emailDays: number[] | null;
    emailTime: string | null;
    pushAppDays: number[] | null;
    pushAppTime: string | null;
    publishStatus: boolean;
    createdBy: string | null;
}

export interface TimeSpan {
    readonly ticks: number;
    readonly days: number;
    readonly hours: number;
    readonly milliseconds: number;
    readonly minutes: number;
    readonly seconds: number;
    readonly totalDays: number;
    readonly totalHours: number;
    readonly totalMilliseconds: number;
    readonly totalMinutes: number;
    readonly totalSeconds: number;
}

export interface NewsDetailModelCms {
    title: string | null;
    description: string | null;
    validFrom: Date;
    validTo: Date;
    tagName: string | null;
    tagId: number;
    blobId: string;
    fileName: string | null;
    fileType: string | null;
    image2BlobId: string | null;
    image2FileName: string | null;
    image2FileType: string | null;
    emailDays: number[] | null;
    emailTime: TimeSpan;
    pushAppDays: number[] | null;
    pushAppTime: TimeSpan;
    publishStatus: boolean;
    pushEmails: number;
    pushApps: number;
}

export interface DropdownListItem {
    id: string | null;
    name: string | null;
}

export interface CreateEditInstalmentPackageModel {
    leasingPartnerId: string;
    provinceCode: string;
    file: FileUploadMeta;
    createdOrUpdatedBy: string | null;
}

export interface InstalmentPackageListItem {
    id: string;
    provinceName: string | null;
    leasingName: string | null;
    packageName: string | null;
}

export interface InstalmentPackageListItemDataGrid {
    totalItems: number;
    totalPages: number;
    items: InstalmentPackageListItem[] | null;
}

export interface InstalmentPackageDetailView {
    leasingPartnerId: string;
    leasingPartnerName: string | null;
    provinceCode: string | null;
    provinceName: string | null;
    cityCode: string | null;
    cityName: string | null;
    blobId: string;
    fileName: string | null;
    fileType: string | null;
}

export interface CreateEditInstalmentPartnerModel {
    name: string;
    websiteLink: string;
    image: FileUploadMeta;
    createdOrUpdatedBy: string | null;
}

export interface InstalmentPartnerListItem {
    id: string;
    name: string | null;
    websiteLink: string | null;
}

export interface InstalmentPartnerListItemDataGrid {
    totalItems: number;
    totalPages: number;
    items: InstalmentPartnerListItem[] | null;
}

export interface InstalmentPartnerDetailView {
    name: string | null;
    websiteLink: string | null;
    blobId: string;
    fileName: string | null;
    fileType: string | null;
}

export interface RolePageMappingRowDataModel {
    userRoleId: number;
    name: string | null;
}

export interface RolePageMappingGridDataModel {
    totalPages: number;
    data: RolePageMappingRowDataModel[] | null;
}

export interface RolePageMappingConfigModel {
    id: number;
    name: string | null;
    hasCreate: boolean;
    hasRead: boolean;
    hasUpdate: boolean;
    hasDelete: boolean;
}

export interface RolePageMappingModel {
    rolePageConfigId: number;
    allowCreate: boolean;
    allowRead: boolean;
    allowUpdate: boolean;
    allowDelete: boolean;
}

export interface RolePageMappingFormModel {
    roleName: string | null;
    configs: RolePageMappingConfigModel[] | null;
    mappings: RolePageMappingModel[] | null;
}

export interface ReportReferralCodeModel {
    outletName: string | null;
    dealerName: string | null;
    fullName: string | null;
    quantity: number;
}

export interface DownloadReportReferralCodeResponse {
    content: string | null;
    fileName: string | null;
    contentType: string | null;
}

export interface GeneralDashboardModel {
    totalUser: number;
    totalActiveUser: number;
    totalCancelService: number;
    totalPresentation: number;
    lastUpdated: string;
    cancelReasonList: CancelReasonList[];
    totalBookingService: number;
    totalClaimVoucher: number;
    totalUserDealer: number;
    totalActiveUserDealer: number;
    totalUserCustomer: number;
    totalActiveUserCustomer: number;
    totalUserBms: number;
    totalActiveUserBms: number;
    totalPresentationQiscus: number;
    totalBookingQiscus: number;
}

export interface GeneralServicePercentageModel {
    totalBib: number;
    totalStall: number;
}

interface CancelReasonList {
    cancelReasonId: number;
    name: string;
    totalReason: number;
}

export interface DashboardChartDataModel {
    totalService: number;
    totalServiceType: number;
    totalBerkala: number;
    totalNonBerkala: number;
    totalVoucherKSGService: number;
    totalFinishedService: number;
    totalOutstandingService: number;
    totalCancelService: number;
    lastDataUpdate: string;
}

export interface RolePageMappingAccessModel {
    allowCreate: boolean;
    allowUpdate: boolean;
    allowDelete: boolean;
}

export interface CarVariantListItem {
    variantId: string;
    name: string | null;
}

export interface CatalogUnitListItemCmsModel {
    modelId: string;
    seriesName: string | null;
    name: string | null;
    dosVariant: string | null;
    variantId: string;
    variantName: string | null;
    isPublish: string | null;
    isUnitDiscontinued: string | null;
}

export interface CatalogUnitDataGridModel {
    totalItems: number;
    totalPages: number;
    items: CatalogUnitListItemCmsModel[] | null;
}

export interface CreateEditCatalogUnitSpecificationModel {
    specificationIndicatorId: number;
    value: string | null;
}

export interface CreateCatalogUnitModel {
    modelId: string;
    dosVariant: string;
    variantName: string;
    specificationIndicators: CreateEditCatalogUnitSpecificationModel[] | null;
    variantImage: FileUploadMeta;
    katalogImage: FileUploadMeta;
    manualBookImage: FileUploadMeta;
    serviceBookImage: FileUploadMeta;
    isPublish: boolean;
    createdByOrUpdatedBy: string | null;
    isUnitDiscontinued: boolean;
}

export interface EditCatalogUnitModel {
    variantImage: FileUploadMeta;
    katalogImage: FileUploadMeta;
    manualBookImage: FileUploadMeta;
    serviceBookImage: FileUploadMeta;
    isPublish: boolean;
    specificationIndicators: CreateEditCatalogUnitSpecificationModel[] | null;
    createdByOrUpdatedBy: string | null;
    variantName: string | null;
    isUnitDiscontinued: boolean;
}

export interface CatalogUnitDetailViewModel {
    seriesId: string;
    seriesName: string | null;
    modelId: string;
    modelName: string | null;
    dosId: string | null;
    dosVariant: string | null;
    variantName: string | null;
    specificationIndicators: CreateEditCatalogUnitSpecificationModel[] | null;
    variantImageName: string | null;
    katalogImageName: string | null;
    manualBookImageName: string | null;
    isPublish: boolean;
    imageBlobId: string;
    imageFileType: string | null;
    manualBookBlobId: string;
    manualBookFileType: string | null;
    serviceBookBlobId: string;
    serviceBookName: string | null;
    serviceBookFileType: string | null;
    katalogBlobId: string;
    katalogFileType: string | null;
    isUnitDiscontinued: boolean;
}

export interface CatalogUnitSpecificationIndicatorModel {
    id: number;
    name: string | null;
    measurement: string | null;
}

export interface CatalogUnitSpecificationModel {
    id: number;
    name: string | null;
    specifications: CatalogUnitSpecificationIndicatorModel[] | null;
}

export interface UnitComparisonConfigDetailModel {
    id: number;
    name: string | null;
    checked: boolean;
}

export interface UnitComparisonConfigListItem {
    id: number;
    name: string | null;
    bodies: UnitComparisonConfigDetailModel[] | null;
}

export interface EditUnitComparisonConfigListItem {
    id: number;
    checked: boolean;
}

export interface EditUnitComparisonConfigModel {
    configs: EditUnitComparisonConfigListItem[];
    updatedBy: string | null;
}

export interface CreateEditSpecificationIndicatorModel {
    specificationId: number;
    specificationDetail: string;
    ordering: number;
    unitOfMeasurement: string | null;
    createdOrUpdatedBy: string | null;
    seriesTypeId: number;
}

export interface SpecificationIndicatorListItem {
    id: number;
    specificationName: string | null;
    specificationDetail: string | null;
    unitOfMeasurement: string | null;
    ordering: number;
    seriesType: string | null;
}

export interface SpecificationIndicatorDataGrid {
    totalItems: number;
    totalPages: number;
    items: SpecificationIndicatorListItem[] | null;
}

export interface SpecificationIndicatorDetailView {
    specificationId: number;
    specificationName: string | null;
    specificationDetail: string | null;
    ordering: number;
    unitOfMeasurement: string | null;
    carSeriesTypeId: number;
}

export interface UnitSpecificationListItem {
    id: number;
    specificationName: string | null;
}

export interface UnitSuggestionListItem {
    id: string;
    typeName: string | null;
    categoryValue: string | null;
    carSeriesName: string | null;
    carModelName: string | null;
    carVariantName: string | null;
}

export interface UnitSuggestionDataGrid {
    totalItems: number;
    totalPages: number;
    items: UnitSuggestionListItem[] | null;
}

export interface CreateUnitSuggestionModel {
    categoryId: string;
    unitIds: string[];
    createdBy: string | null;
}

export interface CreateEditSuggestionCategoryModel {
    suggestionTypeId: number;
    suggestionValue: string;
    createdOrUpdatedBy: string | null;
}

export interface SuggestionCategoryListItem {
    id: string;
    name: string | null;
    value: string | null;
}

export interface SuggestionCategoryDataGrid {
    totalItems: number;
    totalPages: number;
    items: SuggestionCategoryListItem[] | null;
}

export interface SuggestionCategoryDetailView {
    suggestionTypeId: number;
    suggestionTypeName: string | null;
    suggestionValue: string | null;
}

export interface SuggestionCategoryDropdownModel {
    id: string;
    value: string | null;
}

export interface SuggestionTypeListItem {
    id: number;
    name: string | null;
}

export interface CreateUserGuidelineDetailModel {
    ordering: number;
    question: string;
    answer: string;
    isPublish: boolean;
}

export interface CreateUserGuidelineModel {
    guidelineCategoryId: string;
    details: CreateUserGuidelineDetailModel[];
    createdBy: string | null;
}

export interface UserGuidelineListItem {
    userGuidelineId: string;
    userTypeName: string | null;
    guidelineCategoryName: string | null;
    question: string | null;
    answer: string | null;
    ordering: number;
    status: string | null;
}

export interface UserGuidelineListItemDataGrid {
    totalItems: number;
    totalPages: number;
    items: UserGuidelineListItem[] | null;
}

export interface EditUserGuidelineModel {
    guidelineCategoryId: string;
    question: string;
    answer: string;
    ordering: number;
    isPublish: boolean;
    updatedBy: string | null;
}

export interface UserGuidelineDetailView {
    userTypeId: number;
    userGuidelineCategoryId: string;
    userGuidelineCategoryName: string | null;
    question: string | null;
    answer: string | null;
    ordering: number;
    isPublish: boolean;
}

export interface CreateEditUserGuidelineCategory {
    userTypeId: number;
    categoryName: string;
    ordering: number;
    createdOrUpdatedBy: string | null;
}

export interface UserGuidelineCategoryListItem {
    id: string;
    userTypeName: string | null;
    categoryName: string | null;
    ordering: number;
}

export interface UserGuidelineCategoryListItemDataGrid {
    totalItems: number;
    totalPages: number;
    items: UserGuidelineCategoryListItem[] | null;
}

export interface UserGuidelineCategoryDetailView {
    userTypeId: number;
    userTypeName: string | null;
    categoryName: string | null;
    ordering: number;
}

export interface UserRegistrationFormModel {
    email: string;
    npk: string;
    password: string;
    addedBy: string | null;
}

export interface UserRoleMappingListItem {
    userId: string;
    email: string | null;
    npk: string | null;
    accessRoleId: number;
    accessRoleName: string | null;
    status: boolean;
    createdDate: Date;
}

export interface UserRoleMappingDataGrid {
    totalItems: number;
    totalPages: number;
    items: UserRoleMappingListItem[] | null;
}

export interface UserRoleMappingDetailModel {
    userId: string;
    email: string | null;
    npk: string | null;
    accessRoleId: number;
    accessRoleName: string | null;
    status: boolean;
}

export interface UpdateUserRoleMappingModel {
    accessRoleId: number;
    status: boolean;
}

export interface ReportReferralCodeListItem {
    dealerName: string;
    outletName: string;
    fullName: string;
    quantity: number;
}

export interface ReportReferralCodeDataGrid {
    totalItems: number;
    totalPages: number;
    items: ReportReferralCodeListItem[] | null;
}

export interface DownloadReportReferralCode {
    fileName: string;
    contentType: string;
    content: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}